<template>
  <div class="carousel_wrap">
   
    <el-carousel :height="!heightParam?'88vh':heightParam" :interval="3000" :autoplay="true" hover-stop class="hidden-xs-only">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
        
        </div>
      </el-carousel-item>
    </el-carousel>
 

    <el-carousel height="70vw" loop arrow="never" class="hidden-sm-and-up">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" :style="{ width: 'auto', height: '90%', objectFit: 'cover' }" />
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: [],
    },
    heightParam:{
      default:null
    }
  },
  data() {
    return {
      // imgList: [
      //   {
      //     src: require('@/assets/img2/gs2.png'),
      //     line1: '产业大脑',
      //     line2: '赋能产业高质量发展',
      //   }
      // ],
    }
  },
}
</script>

<style lang="scss" scoped>
.carousel_wrap {
  position: relative;
  .el-carousel__item {
    img {
      width: 100%;
      height: 100% !important;
      // object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #fff;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
}
::v-deep{
  .el-carousel__arrow{
    width: 3rem !important;
    height: 3rem !important;
    background: #666666;
    opacity: 0.4;
  }
}

</style>